import {
  getRouteLineSegments, getRouteStopItems, getRouteShiftItems,
} from './routeGanttFormats';
import { getRouteGanttEndMoment, getRouteGanttDefaultStart, getRouteGanttDefaultEnd } from './routeGanttTimes';
import getBackgroundColor from './getBackgroundColor';
import getBorderColor from './getBorderColor';
import { LINE_HEIGHT } from '../../constants';

// The timeline has a buffer of MAX_ZOOM_IN_LEVEL * 3 for performance. We want to disable clustering for
// any time below 3 hours and 1 minute. Setting it to 4 hours provides a consistant experience and is easier to understand.
const LIBRARY_TIMELINE_BUFFER = 4;
export const TINY_STOP_SIZE_DEFAULT = 0.2;
export const CLUSTER_RANGE_DEFAULT = 0.5;
export const MAX_ZOOM_IN_LEVEL = 3600000; // 1 hour in milliseconds
export const MOUSE_OVER_POPUP_DELAY = 0.2;
export const DISABLE_CLUSTERING_BELOW_TIME = MAX_ZOOM_IN_LEVEL * LIBRARY_TIMELINE_BUFFER;
export const TIME_STEPS = [
  {
    timespanInMS: 172800000, // 48hrs
    hour: 6,
    minute: 1,
    second: 1,
    day: 1,
    month: 1,
    year: 1,
  }, {
    timespanInMS: 115200000, // 32hrs
    hour: 4,
    minute: 1,
    second: 1,
    day: 1,
    month: 1,
    year: 1,
  }, {
    timespanInMS: 86400000, // 24hrs
    hour: 4,
    minute: 1,
    second: 1,
    day: 1,
    month: 1,
    year: 1,
  }, {
    timespanInMS: 57600000, // 16hrs
    hour: 4,
    minute: 1,
    second: 1,
    day: 1,
    month: 1,
    year: 1,
  }, {
    timespanInMS: 43200000, // 12hrs
    hour: 2,
    minute: 1,
    second: 1,
    day: 1,
    month: 1,
    year: 1,
  }, {
    timespanInMS: 28800000, // 8hrs
    hour: 1,
    minute: 30,
    second: 1,
    day: 1,
    month: 1,
    year: 1,
  }, {
    timespanInMS: 14400000, // 4hrs
    hour: 1,
    minute: 30,
    second: 1,
    day: 1,
    month: 1,
    year: 1,
  }, {
    timespanInMS: 7200000, // 2hrs
    hour: 1,
    minute: 10,
    second: 1,
    day: 1,
    month: 1,
    year: 1,
  }, {
    timespanInMS: 3600000, // 1hrs
    hour: 1,
    minute: 5,
    second: 1,
    day: 1,
    month: 1,
    year: 1,
  },
];

export const ITEM_KEYS = {
  groupIdKey: 'id',
  groupTitleKey: 'title',
  groupRightTitleKey: 'rightTitle',
  itemIdKey: 'id',
  itemTitleKey: 'title',
  itemDivTitleKey: 'title',
  itemGroupKey: 'group',
  itemTimeStartKey: 'start_time',
  itemTimeEndKey: 'end_time',
};

const hourInMilliseconds = 60 * 60 * 1000; // 60 minutes * 60 seconds * 1000
export const MAX_ZOOM_MILLISECONDS = 48 * hourInMilliseconds; // 48 hours

// sizes are based of design pixel size of 1 character, multiple of 8px.
const getMinDeliveryContentSize = (stopNumberAsString: string) => {
  switch (stopNumberAsString.length) {
    case 1:
      return 8;
    case 2:
      return 16;
    case 3:
      return 24;
    case 4:
      return 32;
    case 5:
      return 40;
    case 6:
      return 48;
    default:
      return 56;
  }
};

const getItemTopPositionOffset = (itemHeight: number) => (LINE_HEIGHT / 2) - (itemHeight / 2);

export {
  getBackgroundColor,
  getBorderColor,
  getRouteLineSegments,
  getRouteStopItems,
  getRouteGanttEndMoment,
  getRouteGanttDefaultEnd,
  getRouteGanttDefaultStart,
  getRouteShiftItems,
  getMinDeliveryContentSize,
  getItemTopPositionOffset,
};
